import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../domain';
import { ConsoleService } from '../widgets/console.service';
import { AuthenticationModalComponent } from './authentication-modal/authentication-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { SESSION_STORAGE_SHOW_AZURE_LOGIN } from 'app/shared/constants';

@Injectable()
export class AuthGuardService implements CanActivate {

	constructor(
		private authSvc: AuthenticationService,
		private console: ConsoleService,
		private matDialog: MatDialog
	){
		this.console.log('[AuthGuard initialized]');
	}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {

		if ('azurelogin' in route.queryParams)
			window.sessionStorage.setItem(SESSION_STORAGE_SHOW_AZURE_LOGIN, 'true');

		return Promise.resolve(this.authSvc.isAuthenticated)
		.then(success => success ? Promise.resolve(success) : this.tryFromMemory())
		.then(success => {
			if(!success){
				AuthenticationModalComponent.open(this.matDialog);
			}
			return success;
		});
	}

	private tryFromMemory(): Promise<boolean> {
		return new Promise(resolve => {
			this.authSvc.tryAuthenticateViaLocalStorage().then(success => {
				this.console.info("Authentication via LocalStorage " + (success ? "SUCCEEDED" : "FAILED"));
				resolve(success);
			})
			.catch(err => {
				this.console.error('Authentication via LocalStorage ERROR: ', err);
				resolve(false);
			});
		});
	}
}